import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const l1RejectedColumns = ({ extraColumns = [], downloadVoucher }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.submittedOn||props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn || ""} */}
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (props) => { 
      console.log(props,'Rejected Props')
      const value = props?.amount||props?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }

      return (
        <div>{amount || ""}</div>
      );
    }
  },
  {
    Header: "Rejected Amount(₹)",
    accessor: "rejectedAmount",
  },
  // {
  //   Header: "Action",
  //   accessor: "",
  //   Cell: (rowData) => { 
  //     return (
  //       <div className="flex items-center gap-x-5">
  //         <div
  //           className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
  //           onClick={() => {
  //             // return onClickViewFile(rowData?.id, rowData)
  //             downloadVoucher(rowData, "Rejected")
  //           }}
  //         >
  //           Download
  //         </div>
  //       </div>
  //     );
  //   },
  // },
  {
    Header: "",
    accessor: "rejectedAmount",
    Cell: () => {
      return <div className={"text-[var(--textRed)]"}>Rejected</div>;
    },
  },
  // {
  //   Header: "Rejected",
  //   accessor: "rejectedAmount",
  //   Cell: (props) => {
  //     const value = props?.row?.original?.rejectedAmount;
  //     if (!value) {
  //       return "-";
  //     }
  //     return <div className={"text-[var(--textRed)]"}>{value}</div>;
  //   },
  // },
];
